import { Expose, Type } from '@nts/std/serialization';
import { PanelMetaData } from "./panel-meta-data";
import { ExtraLayoutMetaData } from './extra-layout-meta-data';
import type { ExtraLayoutMetaDataInterface, LayoutMetaDataInterface, PanelMetaDataInterface, SpacerMetaDataInterface } from '@nts/std/interfaces';

export class LayoutMetaData implements LayoutMetaDataInterface {

  constructor() {
    this.panels = [];
    this.extraFields = new ExtraLayoutMetaData();
  }

  @Expose()
  @Type(() => PanelMetaData)
  panels: PanelMetaDataInterface[];

  @Expose()
  @Type(() => ExtraLayoutMetaData)
  extraFields: ExtraLayoutMetaDataInterface;

  getSpacerByUniqueId(uniqueId: string, panelId?: string): SpacerMetaDataInterface | null {
    const panels = panelId?.length > 0
      ? this.panels.filter((panel) => panel.panelId === panelId)
      : this.panels;

    for (const panel of panels ?? []) {
      const spacer = panel.spacers?.find((item) => item.uniqueId === uniqueId);
      if (spacer != null) {
        return spacer;
      }
    }

    return null;
  }

}
